import SuperRepository from '../superRepository'

export default new (class ProductsRepository extends SuperRepository {
  baseUri() {
    return 'product'
  }
})()
